const plateList = [
  {
    id: '1200',
    parentId: '0',
    sort: null,
    children: [
      {
        id: '1201',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003001',
        name: '现代金银贵金属币',
        ycname: '现代金银贵金属币',
        url: 'http://www.lc0011.net/index.asp?boardid=9',
        sortno: 1,
        dispflag: 0,
        daycount: 381,
        subcount: 623498,
        allcount: 2975970,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '719',
      },
      {
        id: '1202',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003002',
        name: '普通纪念币',
        ycname: '普通纪念币',
        url: 'http://www.pm001.net/index.asp?boardid=10',
        sortno: 2,
        dispflag: 0,
        daycount: 231,
        subcount: 557696,
        allcount: 2630750,
        manager: '和平使者 松林山人',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '928',
      },
      {
        id: '1203',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003003',
        name: '一二三版纸币',
        ycname: '一二三版纸币',
        url: 'http://www.lc0011.net/index.asp?boardid=11',
        sortno: 3,
        dispflag: 0,
        daycount: 305,
        subcount: 483573,
        allcount: 2527971,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '2238',
      },
      {
        id: '1204',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003004',
        name: '第四版纸币',
        ycname: '第四版纸币',
        url: 'http://www.lc0011.net/index.asp?boardid=119',
        sortno: 4,
        dispflag: 0,
        daycount: 302,
        subcount: 570051,
        allcount: 2745729,
        manager: '刘帮良 dongguo0',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '1295',
      },
      {
        id: '1205',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003005',
        name: '纸币冠号（不含流通纸币）',
        ycname: '纸币冠号（不含流通纸币）',
        url: 'http://www.lc0011.net/index.asp?boardid=128',
        sortno: 5,
        dispflag: 0,
        daycount: 29,
        subcount: 63949,
        allcount: 405649,
        manager: 'binghe',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '542',
      },
      {
        id: '1206',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003006',
        name: '古币银元',
        ycname: '古币银元',
        url: 'http://www.lc0011.net/index.asp?boardid=148',
        sortno: 6,
        dispflag: 0,
        daycount: 322,
        subcount: 445493,
        allcount: 3102524,
        manager: 'xiao李飞刀 彭兵',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '767',
      },
      {
        id: '1207',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003007',
        name: '联体钞/纪念钞',
        ycname: '联体钞/纪念钞',
        url: 'http://www.pm001.net/index.asp?boardid=151',
        sortno: 7,
        dispflag: 0,
        daycount: 212,
        subcount: 566452,
        allcount: 2980131,
        manager: '江山一片紅',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '1227',
      },
      {
        id: '1208',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003008',
        name: '硬币专栏',
        ycname: '硬币专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=210',
        sortno: 8,
        dispflag: 0,
        daycount: 54,
        subcount: 106274,
        allcount: 628904,
        manager: '杭州小孔',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '314',
      },
      {
        id: '1209',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003009',
        name: '港澳台钱币专栏',
        ycname: '港澳台钱币专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=184',
        sortno: 9,
        dispflag: 0,
        daycount: 56,
        subcount: 87260,
        allcount: 551426,
        manager: '名铭在线',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '325',
      },
      {
        id: '1210',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003010',
        name: '清朝民国纸币/老银票',
        ycname: '清朝民国纸币/老银票',
        url: 'http://www.lc0011.net/index.asp?boardid=163',
        sortno: 10,
        dispflag: 0,
        daycount: 38,
        subcount: 38590,
        allcount: 275030,
        manager: '刘帮良 山西一刀',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '239',
      },
      {
        id: '1211',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003011',
        name: '贵金属金银铜纪念章',
        ycname: '贵金属金银铜纪念章',
        url: 'http://www.lc0011.net/index.asp?boardid=165',
        sortno: 11,
        dispflag: 0,
        daycount: 44,
        subcount: 47226,
        allcount: 313639,
        manager: 'xiao李飞刀',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '259',
      },
      {
        id: '1212',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003012',
        name: '外国纸币、硬币',
        ycname: '外国纸币、硬币',
        url: 'http://www.lc0011.net/index.asp?boardid=169',
        sortno: 12,
        dispflag: 0,
        daycount: 24,
        subcount: 20647,
        allcount: 123091,
        manager: '昆仑使者',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '230',
      },
      {
        id: '1213',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003013',
        name: '新中国兑换券、债券、测试券',
        ycname: '新中国兑换券、债券、测试券',
        url: 'http://www.lc0011.net/index.asp?boardid=171',
        sortno: 13,
        dispflag: 0,
        daycount: 13,
        subcount: 19902,
        allcount: 138196,
        manager: '昆仑使者',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '198',
      },
      {
        id: '1214',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003014',
        name: '钱币册/钱币书籍等集币工具',
        ycname: '钱币册/钱币书籍等集币工具',
        url: 'http://www.lc0011.net/index.asp?boardid=208',
        sortno: 14,
        dispflag: 0,
        daycount: 23,
        subcount: 15331,
        allcount: 210091,
        manager: '徐州刘强',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '226',
      },
      {
        id: '1215',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003015',
        name: '钱币套装礼品专栏',
        ycname: '钱币套装礼品专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=209',
        sortno: 15,
        dispflag: 0,
        daycount: 33,
        subcount: 20348,
        allcount: 106599,
        manager: '徐州刘强',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '217',
      },
      {
        id: '1216',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003016',
        name: '评级币评级钞',
        ycname: '评级币评级钞',
        url: 'http://www.lc0011.net/index.asp?boardid=136',
        sortno: 16,
        dispflag: 0,
        daycount: 54,
        subcount: 115193,
        allcount: 656961,
        manager: '昆仑使者',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '258',
      },
      {
        id: '1217',
        parentId: '1200',
        sort: null,
        children: null,
        pid: 1200,
        code: 'Y003017',
        name: '钱币交易仲裁区',
        ycname: '钱币交易仲裁区',
        url: 'http://www.lc0011.net/index.asp?boardid=173',
        sortno: 17,
        dispflag: 0,
        daycount: 0,
        subcount: 1410,
        allcount: 10659,
        manager: '名铭在线',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '194',
      },
    ],
    pid: 0,
    code: 'Y003',
    name: '钱币大卖场',
    ycname: '钱币大卖场',
    url: 'http://www.lc0011.net/index.asp?boardid=2',
    sortno: 1,
    dispflag: 0,
    daycount: 0,
    subcount: 0,
    allcount: 0,
    manager: '',
    lastupdatetime: null,
    onlineCount: null,
  },
  {
    id: '1100',
    parentId: '0',
    sort: null,
    children: [
      {
        id: '1101',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002001',
        name: '小版张专栏',
        ycname: '小版张专栏',
        url: 'http://www.pm001.net/index.asp?boardid=5',
        sortno: 1,
        dispflag: 0,
        daycount: 47,
        subcount: 85794,
        allcount: 476422,
        manager: '一只小蚂蚁',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '300',
      },
      {
        id: '1102',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002002',
        name: '编年版票专栏',
        ycname: '编年版票专栏',
        url: 'http://www.pm001.net/index.asp?boardid=159',
        sortno: 2,
        dispflag: 0,
        daycount: 81,
        subcount: 132351,
        allcount: 754716,
        manager: '法平若水',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '309',
      },
      {
        id: '1103',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002003',
        name: '编年套票栏目',
        ycname: '编年套票栏目',
        url: 'http://www.pm001.net/index.asp?boardid=196',
        sortno: 3,
        dispflag: 0,
        daycount: 144,
        subcount: 154440,
        allcount: 938383,
        manager: '法平若水 石高军',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '412',
      },
      {
        id: '1104',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002004',
        name: '小型张/小全张',
        ycname: '小型张/小全张',
        url: 'http://www.pm001.net/index.asp?boardid=30',
        sortno: 4,
        dispflag: 0,
        daycount: 65,
        subcount: 72476,
        allcount: 416172,
        manager: '苏州蒋浩 亚光',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '387',
      },
      {
        id: '1105',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002005',
        name: '特殊版式小型张/小全张',
        ycname: '特殊版式小型张/小全张',
        url: 'http://www.pm001.net/index.asp?boardid=197',
        sortno: 5,
        dispflag: 0,
        daycount: 162,
        subcount: 42628,
        allcount: 231635,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '417',
      },
      {
        id: '1106',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002006',
        name: '小本票/大本册专栏',
        ycname: '小本票/大本册专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=162',
        sortno: 6,
        dispflag: 0,
        daycount: 24,
        subcount: 30727,
        allcount: 178391,
        manager: '阿明 苏州蒋浩',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '204',
      },
      {
        id: '1107',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002007',
        name: '纪特文编JT新票栏目',
        ycname: '纪特文编JT新票栏目',
        url: 'http://www.lc0011.net/index.asp?boardid=8',
        sortno: 7,
        dispflag: 0,
        daycount: 96,
        subcount: 109124,
        allcount: 830126,
        manager: '阿明 法平若水',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '444',
      },
      {
        id: '1108',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002008',
        name: '纪特文编JT销封栏目',
        ycname: '纪特文编JT销封栏目',
        url: 'http://www.lc0011.net/index.asp?boardid=161',
        sortno: 8,
        dispflag: 0,
        daycount: 32,
        subcount: 40694,
        allcount: 311306,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '249',
      },
      {
        id: '1109',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002009',
        name: '邮资片JP专栏',
        ycname: '邮资片JP专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=7',
        sortno: 9,
        dispflag: 0,
        daycount: 10,
        subcount: 19713,
        allcount: 127076,
        manager: '北京小匡',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '196',
      },
      {
        id: '1110',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002010',
        name: 'JF封/其它类封',
        ycname: 'JF封/其它类封',
        url: 'http://www.lc0011.net/index.asp?boardid=193',
        sortno: 10,
        dispflag: 0,
        daycount: 17,
        subcount: 28903,
        allcount: 216357,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '219',
      },
      {
        id: '1111',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002011',
        name: '邮资片TP/YP/FP',
        ycname: '邮资片TP/YP/FP',
        url: 'http://www.lc0011.net/index.asp?boardid=191',
        sortno: 11,
        dispflag: 0,
        daycount: 8,
        subcount: 6610,
        allcount: 47967,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '189',
      },
      {
        id: '1112',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002012',
        name: '普封普片',
        ycname: '普封普片',
        url: 'http://www.lc0011.net/index.asp?boardid=190',
        sortno: 12,
        dispflag: 0,
        daycount: 10,
        subcount: 22394,
        allcount: 151016,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '222',
      },
      {
        id: '1113',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002013',
        name: '贺年封片简卡',
        ycname: '贺年封片简卡',
        url: 'http://www.lc0011.net/index.asp?boardid=160',
        sortno: 13,
        dispflag: 0,
        daycount: 4,
        subcount: 8969,
        allcount: 69942,
        manager: '易集藏',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '174',
      },
      {
        id: '1114',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002014',
        name: '原地实寄/外交/极限等封片',
        ycname: '原地实寄/外交/极限等封片',
        url: 'http://www.lc0011.net/index.asp?boardid=199',
        sortno: 14,
        dispflag: 0,
        daycount: 9,
        subcount: 8442,
        allcount: 76774,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '197',
      },
      {
        id: '1115',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002015',
        name: '贺年邮票/贺卡邮票/军邮邮票',
        ycname: '贺年邮票/贺卡邮票/军邮邮票',
        url: 'http://www.lc0011.net/index.asp?boardid=195',
        sortno: 15,
        dispflag: 0,
        daycount: 2,
        subcount: 8205,
        allcount: 45293,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '175',
      },
      {
        id: '1116',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002016',
        name: '港澳邮票专栏',
        ycname: '港澳邮票专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=143',
        sortno: 16,
        dispflag: 0,
        daycount: 7,
        subcount: 10882,
        allcount: 60199,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '213',
      },
      {
        id: '1117',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002017',
        name: '个性化原票专栏',
        ycname: '个性化原票专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=192',
        sortno: 17,
        dispflag: 0,
        daycount: 7,
        subcount: 13147,
        allcount: 72095,
        manager: '雏龙欲飞',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '174',
      },
      {
        id: '1118',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002018',
        name: '普区民清加改欠外',
        ycname: '普区民清加改欠外',
        url: 'http://www.lc0011.net/index.asp?boardid=124',
        sortno: 18,
        dispflag: 0,
        daycount: 9,
        subcount: 17330,
        allcount: 145578,
        manager: 'pplw',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '209',
      },
      {
        id: '1119',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002019',
        name: '年册/集邮工具',
        ycname: '年册/集邮工具',
        url: 'http://www.lc0011.net/index.asp?boardid=120',
        sortno: 19,
        dispflag: 0,
        daycount: 71,
        subcount: 104553,
        allcount: 756852,
        manager: '苏州蒋浩',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '291',
      },
      {
        id: '1120',
        parentId: '1100',
        sort: null,
        children: null,
        pid: 1100,
        code: 'Y002020',
        name: '邮票大类产品票礼品册',
        ycname: '邮票大类产品票礼品册',
        url: 'http://www.lc0011.net/index.asp?boardid=211',
        sortno: 20,
        dispflag: 0,
        daycount: 105,
        subcount: 55499,
        allcount: 338383,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '206',
      },
    ],
    pid: 0,
    code: 'Y002',
    name: '邮票大卖场',
    ycname: '邮票大卖场',
    url: 'http://www.lc0011.net/index.asp?boardid=1',
    sortno: 2,
    dispflag: 0,
    daycount: 0,
    subcount: 0,
    allcount: 0,
    manager: '',
    lastupdatetime: null,
    onlineCount: null,
  },
  {
    id: '1300',
    parentId: '0',
    sort: null,
    children: [
      {
        id: '1301',
        parentId: '1300',
        sort: null,
        children: null,
        pid: 1300,
        code: 'Y004001',
        name: '田村卡IC卡专栏',
        ycname: '田村卡IC卡专栏',
        url: 'http://www.pm001.net/index.asp?boardid=74',
        sortno: 1,
        dispflag: 0,
        daycount: 14,
        subcount: 6094,
        allcount: 41372,
        manager: '朽木',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '143',
      },
      {
        id: '1302',
        parentId: '1300',
        sort: null,
        children: null,
        pid: 1300,
        code: 'Y004002',
        name: '其它卡类卖场',
        ycname: '其它卡类卖场',
        url: 'http://www.pm001.net/index.asp?boardid=185',
        sortno: 2,
        dispflag: 0,
        daycount: 0,
        subcount: 977,
        allcount: 7313,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '128',
      },
    ],
    pid: 0,
    code: 'Y004',
    name: '卡类大卖场',
    ycname: '卡类大卖场',
    url: 'http://www.lc0011.net/index.asp?boardid=3',
    sortno: 3,
    dispflag: 0,
    daycount: 0,
    subcount: 0,
    allcount: 0,
    manager: '',
    lastupdatetime: null,
    onlineCount: null,
  },
  {
    id: '1400',
    parentId: '0',
    sort: null,
    children: [
      {
        id: '1401',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005001',
        name: '打折票打折卡',
        ycname: '打折票打折卡',
        url: 'http://www.lc0011.net/index.asp?boardid=14',
        sortno: 1,
        dispflag: 0,
        daycount: 19,
        subcount: 30571,
        allcount: 175669,
        manager: '昆仑使者',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '176',
      },
      {
        id: '1402',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005002',
        name: '古玩金银铜瓷陶器',
        ycname: '古玩金银铜瓷陶器',
        url: 'http://www.lc0011.net/index.asp?boardid=23',
        sortno: 2,
        dispflag: 0,
        daycount: 13,
        subcount: 12732,
        allcount: 108262,
        manager: '名铭在线',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '150',
      },
      {
        id: '1403',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005003',
        name: '古玩竹木雕漆器',
        ycname: '古玩竹木雕漆器',
        url: 'http://www.lc0011.net/index.asp?boardid=155',
        sortno: 3,
        dispflag: 0,
        daycount: 3,
        subcount: 3495,
        allcount: 46171,
        manager: '名铭在线',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '135',
      },
      {
        id: '1404',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005004',
        name: '当代新制玉器',
        ycname: '当代新制玉器',
        url: 'http://www.lc0011.net/index.asp?boardid=166',
        sortno: 4,
        dispflag: 0,
        daycount: 8,
        subcount: 8747,
        allcount: 112690,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '134',
      },
      {
        id: '1405',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005005',
        name: '历代古玉器',
        ycname: '历代古玉器',
        url: 'http://www.lc0011.net/index.asp?boardid=198',
        sortno: 5,
        dispflag: 0,
        daycount: 0,
        subcount: 1656,
        allcount: 12831,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '131',
      },
      {
        id: '1406',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005006',
        name: '书报字画',
        ycname: '书报字画',
        url: 'http://www.lc0011.net/index.asp?boardid=157',
        sortno: 6,
        dispflag: 0,
        daycount: 19,
        subcount: 21451,
        allcount: 243151,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '157',
      },
      {
        id: '1407',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005007',
        name: '茶叶等土特产',
        ycname: '茶叶等土特产',
        url: 'http://www.lc0011.net/index.asp?boardid=212',
        sortno: 7,
        dispflag: 0,
        daycount: 0,
        subcount: 313,
        allcount: 6365,
        manager: '阿拉捂邮',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '126',
      },
      {
        id: '1408',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005008',
        name: '其它古玩杂件藏品',
        ycname: '其它古玩杂件藏品',
        url: 'http://www.lc0011.net/index.asp?boardid=187',
        sortno: 8,
        dispflag: 0,
        daycount: 41,
        subcount: 28401,
        allcount: 320438,
        manager: '福星随缘阁',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '185',
      },
      {
        id: '1409',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005009',
        name: '票证专栏',
        ycname: '票证专栏',
        url: 'http://www.lc0011.net/index.asp?boardid=149',
        sortno: 9,
        dispflag: 0,
        daycount: 11,
        subcount: 10815,
        allcount: 122452,
        manager: 'binghe',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '132',
      },
      {
        id: '1410',
        parentId: '1400',
        sort: null,
        children: null,
        pid: 1400,
        code: 'Y005010',
        name: '礼品集藏工具',
        ycname: '礼品集藏工具',
        url: 'http://www.lc0011.net/index.asp?boardid=207',
        sortno: 10,
        dispflag: 0,
        daycount: 0,
        subcount: 1550,
        allcount: 9848,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '131',
      },
    ],
    pid: 0,
    code: 'Y005',
    name: '其它品种大卖场',
    ycname: '其它品种大卖场',
    url: 'http://www.lc0011.net/index.asp?boardid=4',
    sortno: 4,
    dispflag: 0,
    daycount: 0,
    subcount: 0,
    allcount: 0,
    manager: '',
    lastupdatetime: null,
    onlineCount: null,
  },
  {
    id: '1000',
    parentId: '0',
    sort: null,
    children: [
      {
        id: '1001',
        parentId: '1000',
        sort: null,
        children: null,
        pid: 1000,
        code: 'Y001001',
        name: '投诉暴光台',
        ycname: '投诉暴光台',
        url: 'http://www.pm001.net/index.asp?boardid=16',
        sortno: 1,
        dispflag: 0,
        daycount: 1,
        subcount: 706,
        allcount: 4004,
        manager: '一只小蚂蚁',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '125',
      },
      {
        id: '1002',
        parentId: '1000',
        sort: null,
        children: null,
        pid: 1000,
        code: 'Y001002',
        name: '交易视点',
        ycname: '交易视点',
        url: 'http://www.pm001.net/index.asp?boardid=19',
        sortno: 2,
        dispflag: 0,
        daycount: 0,
        subcount: 3898,
        allcount: 15565,
        manager: '凌云木',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '131',
      },
      {
        id: '1003',
        parentId: '1000',
        sort: null,
        children: null,
        pid: 1000,
        code: 'Y001003',
        name: '中介支付专栏',
        ycname: '中介支付专栏',
        url: 'http://www.pm001.net/index.asp?boardid=147',
        sortno: 3,
        dispflag: 0,
        daycount: 0,
        subcount: 2937,
        allcount: 23278,
        manager: '雨馨阁 听风吹雨',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '128',
      },
      {
        id: '1004',
        parentId: '1000',
        sort: null,
        children: null,
        pid: 1000,
        code: 'Y001004',
        name: '高级会员信息发布区',
        ycname: '高级会员信息发布区',
        url: 'http://www.pm001.net/index.asp?boardid=206',
        sortno: 4,
        dispflag: 0,
        daycount: 32,
        subcount: 26043,
        allcount: 173277,
        manager: '此版暂无版主',
        lastupdatetime: '2023-08-04T16:24:32',
        onlineCount: '208',
      },
    ],
    pid: 0,
    code: 'Y001',
    name: '交易帮助',
    ycname: '交易帮助',
    url: 'http://www.pm001.net/index.asp?boardid=17',
    sortno: 5,
    dispflag: 0,
    daycount: 0,
    subcount: 0,
    allcount: 0,
    manager: '',
    lastupdatetime: null,
    onlineCount: null,
  },
];

export default plateList;
